// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"29f2bcc3","453":"03b67575","455":"cf31f15b"}[chunkId] + ".chunk.js";
};